// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__G7SHE","footer":"ReportModalFilter_footer__3UeYc"};